import MainContainer from "../../components/container/MainContainer";

const ExpenditureVarianceReport = () => {
  return <MainContainer>ExpenditureVarianceReport</MainContainer>;
};

export default ExpenditureVarianceReport;
